// <auto-generated/>
// Contents of: hl7.fhir.r4.core version: 4.0.1
  // Primitive Naming Style: None
  // Complex Type / Resource Naming Style: PascalCase
  // Interaction Naming Style: None
  // Extension Support: NonPrimitive
  // Restricted to: Patient|Encounter|Questionnaire|QuestionnaireResponse|Observation|GuidanceResponse|CarePlan|ServiceRequest|Parameters|OperationOutcome
  // Language option: "namespaceRoot" = "IntgelligentNav.Fhir"
  // Language option: "partialClasses" = "true"
  // Language option: "systemTextJson" = "true"
  // Language option: "tolerantEnums" = "true"
  // Language option: "singleFile" = "false"
// Minimum TypeScript Version: 3.7
import * as fhir from '../fhir'
/**
 * For referring to data content defined in other formats.
 */
export type IAttachment = fhir.IFhirElement & {
  /**
   * Identifies the type of the data in the attachment and allows a method to be chosen to interpret or render the data. Includes mime type parameters such as charset where appropriate.
   */
  contentType?: string|undefined;
  _contentType?: fhir.IFhirElement|undefined;
  /**
   * The date that the attachment was first created.
   */
  creation?: string|undefined;
  _creation?: fhir.IFhirElement|undefined;
  /**
   * The base64-encoded data SHALL be expressed in the same character set as the base resource XML or JSON.
   */
  data?: string|undefined;
  _data?: fhir.IFhirElement|undefined;
  /**
   * The hash is calculated on the data prior to base64 encoding, if the data is based64 encoded. The hash is not intended to support digital signatures. Where protection against malicious threats a digital signature should be considered, see [Provenance.signature](provenance-definitions.html#Provenance.signature) for mechanism to protect a resource with a digital signature.
   */
  hash?: string|undefined;
  _hash?: fhir.IFhirElement|undefined;
  /**
   * The human language of the content. The value can be any valid value according to BCP 47.
   */
  language?: string|undefined;
  _language?: fhir.IFhirElement|undefined;
  /**
   * The number of bytes is redundant if the data is provided as a base64binary, but is useful if the data is provided as a url reference.
   */
  size?: number|undefined;
  _size?: fhir.IFhirElement|undefined;
  /**
   * A label or set of text to display in place of the data.
   */
  title?: string|undefined;
  _title?: fhir.IFhirElement|undefined;
  /**
   * If both data and url are provided, the url SHALL point to the same content as the data contains. Urls may be relative references or may reference transient locations such as a wrapping envelope using cid: though this has ramifications for using signatures. Relative URLs are interpreted relative to the service url, like a resource reference, rather than relative to the resource itself. If a URL is provided, it SHALL resolve to actual data.
   */
  url?: string|undefined;
  _url?: fhir.IFhirElement|undefined;
}
/**
 * For referring to data content defined in other formats.
 */
export class Attachment extends fhir.FhirElement implements fhir.IAttachment {
  /**
   * Identifies the type of the data in the attachment and allows a method to be chosen to interpret or render the data. Includes mime type parameters such as charset where appropriate.
   */
  public contentType?: string|undefined;
  public _contentType?: fhir.FhirElement|undefined;
  /**
   * The date that the attachment was first created.
   */
  public creation?: string|undefined;
  public _creation?: fhir.FhirElement|undefined;
  /**
   * The base64-encoded data SHALL be expressed in the same character set as the base resource XML or JSON.
   */
  public data?: string|undefined;
  public _data?: fhir.FhirElement|undefined;
  /**
   * The hash is calculated on the data prior to base64 encoding, if the data is based64 encoded. The hash is not intended to support digital signatures. Where protection against malicious threats a digital signature should be considered, see [Provenance.signature](provenance-definitions.html#Provenance.signature) for mechanism to protect a resource with a digital signature.
   */
  public hash?: string|undefined;
  public _hash?: fhir.FhirElement|undefined;
  /**
   * The human language of the content. The value can be any valid value according to BCP 47.
   */
  public language?: string|undefined;
  public _language?: fhir.FhirElement|undefined;
  /**
   * The number of bytes is redundant if the data is provided as a base64binary, but is useful if the data is provided as a url reference.
   */
  public size?: number|undefined;
  public _size?: fhir.FhirElement|undefined;
  /**
   * A label or set of text to display in place of the data.
   */
  public title?: string|undefined;
  public _title?: fhir.FhirElement|undefined;
  /**
   * If both data and url are provided, the url SHALL point to the same content as the data contains. Urls may be relative references or may reference transient locations such as a wrapping envelope using cid: though this has ramifications for using signatures. Relative URLs are interpreted relative to the service url, like a resource reference, rather than relative to the resource itself. If a URL is provided, it SHALL resolve to actual data.
   */
  public url?: string|undefined;
  public _url?: fhir.FhirElement|undefined;
  /**
   * Default constructor for Attachment - initializes any required elements to null if a value is not provided.
   */
  constructor(source:Partial<fhir.IAttachment> = {}) {
    super(source);
    if (source["contentType"]) { this.contentType = source.contentType; }
    if (source["_contentType"]) { this._contentType = new fhir.FhirElement(source._contentType!); }
    if (source["creation"]) { this.creation = source.creation; }
    if (source["_creation"]) { this._creation = new fhir.FhirElement(source._creation!); }
    if (source["data"]) { this.data = source.data; }
    if (source["_data"]) { this._data = new fhir.FhirElement(source._data!); }
    if (source["hash"]) { this.hash = source.hash; }
    if (source["_hash"]) { this._hash = new fhir.FhirElement(source._hash!); }
    if (source["language"]) { this.language = source.language; }
    if (source["_language"]) { this._language = new fhir.FhirElement(source._language!); }
    if (source["size"]) { this.size = source.size; }
    if (source["_size"]) { this._size = new fhir.FhirElement(source._size!); }
    if (source["title"]) { this.title = source.title; }
    if (source["_title"]) { this._title = new fhir.FhirElement(source._title!); }
    if (source["url"]) { this.url = source.url; }
    if (source["_url"]) { this._url = new fhir.FhirElement(source._url!); }
  }
  /**
   * Check if the current Attachment contains all required elements.
   */
  override checkRequiredElements():string[] {
    var missingElements:string[] = [];
    var parentMissing:string[] = super.checkRequiredElements();
    missingElements.push(...parentMissing);
    return missingElements;
  }
  /**
   * Factory function to create a Attachment from an object that MUST contain all required elements.
   */
  static override fromStrict(source:fhir.IAttachment):Attachment {
    var dest:Attachment = new Attachment(source);
    var missingElements:string[] = dest.checkRequiredElements();
    if (missingElements.length !== 0) { throw `Attachment is missing elements: ${missingElements.join(", ")}` }
    return dest;
  }
}
